import { TaskInputItem } from './taskinputitem';

export class TaskInput {
  hasNext: boolean;
  items: Array<TaskInputItem>;
  total: number;
}
